import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { GridColumn, GridRow } from "arv-reactcomponents";

import ConsignmentView from "../ConsignmentView";

class ConsignmentWrapper extends PureComponent {
  render() {
    const { returnClick } = this.props;
    const { consignments = [] } = this.props.orderDetails;
    return (
      <Fragment>
        {consignments.map((consignment, index) => (
          <ConsignmentView.component
            consignment={consignment}
            key={consignment.consignmentId}
            consignmentNumber={index + 1}
            returnClick={returnClick}
          />
        ))}
      </Fragment>
    );
  }
}

ConsignmentWrapper.defaultProps = {
  orderDetails: {
    consignments: [],
  },
};

ConsignmentWrapper.propTypes = {
  orderDetails: PropTypes.shape({
    consignments: PropTypes.arrayOf(PropTypes.object),
  }),
  returnClick: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentWrapper,
  component: ConsignmentWrapper,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/ConsignmentWrapper/index.js